import { Col, Row, Spin, Steps } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import ButtonStandard from "../../../../../../../../components/utils/button";
import useStatementContext from "../../../../../../../../hooks/useStatementContext";
import {
  ImportStatementFormProvider,
  useImportStatementFormContext,
} from "./context";

// import { Container } from './styles';

function ImportStatementFormLayout() {
  const { handleCloseStatementImportForm } = useStatementContext();
  const { isLoading, currentStep, steps, next, prev } =
    useImportStatementFormContext();
  const { translation } = useSelector((state) => state.app);

  function handleClose() {
    handleCloseStatementImportForm();
  }

  return (
    <div style={{ padding: "32px 20px 22px 25px" }}>
      <Spin spinning={isLoading}>
        <Row type="flex">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Steps current={currentStep}>
              {steps.map((item) => (
                <Steps.Step
                  key={item.title}
                  title={translation.statement.form.steps[item.title]}
                />
              ))}
            </Steps>
          </Col>
        </Row>
        <Row type="flex">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            {steps[currentStep].content}
          </Col>
        </Row>
        <Row
          type="flex"
          justify="space-between"
          gutter={16}
          style={{ width: "100%" }}
        >
          <Col span={2}>
            <ButtonStandard
              type="button"
              buttonType="type7"
              onClick={handleClose}
            >
              {translation.buttons.cancel}
            </ButtonStandard>
          </Col>
          {currentStep > 0 && (
            <Col span={2}>
              <ButtonStandard type="button" buttonType="type6" onClick={prev}>
                {translation.buttons.back}
              </ButtonStandard>
            </Col>
          )}
          {currentStep < steps.length - 1 && (
            <Col span={2}>
              <ButtonStandard type="button" buttonType="type6" onClick={next}>
                {translation.buttons.next}
              </ButtonStandard>
            </Col>
          )}
          {currentStep === steps.length - 1 && (
            <Col span={2}>
              <ButtonStandard type="button" buttonType="type6" onClick={next}>
                {translation.buttons.save}
              </ButtonStandard>
            </Col>
          )}
        </Row>
      </Spin>
    </div>
  );
}

const ImportStatementForm = () => {
  return (
    <ImportStatementFormProvider>
      <ImportStatementFormLayout />
    </ImportStatementFormProvider>
  );
};

export default ImportStatementForm;
